import EventBus from "eventing-bus"
import {
  constants,
  getCurrSection,
  getSwipeDirection,
  getCurrBoard,
  getCurrTruck,
  getModelsArr,
  getTruckModelsArr,
  getWheelModelsArr,
  getCurrWheel,
} from "../model"
import gsap from "gsap"

const titleEl = document.querySelector(".board-title")
const priceEl = document.querySelector(".board-price")

const handleSectionChanged = () => {
  if (getCurrSection() === 0) {
    handleBoardChanged()
  }
  if (getCurrSection() === 1) {
    handleTruckChanged()
  }
  if (getCurrSection() === 2) {
    handleWheelChanged()
  }
}

const handleBoardChanged = () => {
  const data = getModelsArr()[getCurrBoard()]
  changeText(data.name, data.price)
}

const handleTruckChanged = () => {
  const data = getTruckModelsArr()[getCurrTruck()]
  changeText(data.name, data.price)
}

const handleWheelChanged = () => {
  const data = getWheelModelsArr()[getCurrWheel()]
  changeText(data.name, data.price)
}

const changeText = (name, price) => {
  const x = getSwipeDirection() === "left" ? -100 : 100
  gsap.to(titleEl, { duration: 0.6, alpha: 0, x: 150, ease: "power4.in" })
  gsap.to(priceEl, { duration: 1, alpha: 0, ease: "power4.out" })
  setTimeout(() => {
    titleEl.innerHTML = name
    const priceStr = "$" + price + ".00"
    priceEl.innerHTML = priceStr
    gsap.fromTo(titleEl, { x: -150 }, { duration: 0.6, alpha: 1, x: 0, ease: "power4.out" })
    gsap.to(priceEl, { duration: 1, alpha: 1, delay: 0.75, ease: "power2.out" })
  }, 600)
}

EventBus.on(constants.TRUCK_CHANGED, handleTruckChanged)
EventBus.on(constants.WHEEL_CHANGED, handleWheelChanged)
EventBus.on(constants.BOARD_CHANGED, handleBoardChanged)
EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
